import React, { useEffect, useState } from 'react';

const Online = () => {
    const [memberNames, setMemberNames] = useState('');
    const [validUsers, setValidUsers] = useState([]);
    const excludedUsernames = ['Emergency Medical Services'];

    useEffect(() => {
        fetch('https://ems.lexikonn.eu/api/get_records.php')
            .then(res => res.json())
            .then(data => {
                const uniqueUsers = Array.from(new Set(data.map(r => r.user).filter(Boolean)));
                setValidUsers(uniqueUsers);
            });
    }, []);

    useEffect(() => {
        if (validUsers.length === 0) return;
        fetch('https://discord.com/api/guilds/1357777489937567824/widget.json')
            .then(res => res.json())
            .then(data => {
                const filtered = data.members
                    .filter(m => !excludedUsernames.includes(m.username))
                    .filter(m => validUsers.includes(m.username))
                    .map(m => m.username)
                    .join(', ');

                setMemberNames(filtered);
            });
    }, [validUsers]);

    return (
        <div className="container py-4">
            <strong>Dostupné jednotky:</strong> {memberNames || 'Žádná online jednotka není evidována'}
        </div>
    );
};

export default Online;
